<template>
    <div>
        <el-card class="fatherCard" >
            <div slot="header">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item><i class="el-icon-location-outline"></i> <b>当前位置</b></el-breadcrumb-item>
                    <el-breadcrumb-item>考试管理</el-breadcrumb-item>                
                    <el-breadcrumb-item>考试管理</el-breadcrumb-item>
                    <el-breadcrumb-item>考试记录</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="page_content">
                <div class="exam_info">
                    <div class="left_info">
                        <div class="info_title">
                            <h3>考试记录</h3>   
                            <span class="singAnswerTip">从以下列表查看和管理考生的答卷记录。</span>
                        </div>
                        <table class="info_table">
                            <tbody>
                                <tr>
                                    <th style="width:100px">考试名称</th>
                                    <td>{{examInfo.examName}}</td>
                                </tr>
                                <tr>
                                    <th>考试时间</th>
                                    <td>{{examInfo.examStartTime}}</td>  
                                </tr>
                                <tr>
                                    <th>考试时长</th>
                                    <td>{{examInfo.examDuration}} 分钟</td>                                    
                                </tr>
                                <tr>
                                    <th>卷面总分</th>
                                    <td>{{examInfo.paper.paperScore}} 分（及格分：{{examInfo.paper.passScore}} 分） </td>                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="right_area">
                        <div >
                            <el-button size="small" icon="el-icon-back" @click="backToExamManage()">返回</el-button>
                            <el-button size="small" icon="el-icon-refresh" @click="refresh()">刷新</el-button>
                        </div>
                        <div >
                            <el-select v-model="queryRecordParams.userId" @change="queryExamRes()" clearable filterable placeholder="用户名称查询" class="queryParam">
                                <el-option v-for="item in userList" :key="item.userId" :label="item.relayName" :value="item.userId" >
                                </el-option>
                            </el-select>
                            <el-select v-model="queryRecordParams.hasCorrect" @change="queryExamRes()" clearable placeholder="是否批阅" class="queryParam">
                                <el-option label="未批阅"  value="0" ></el-option>   
                                <el-option label="已批阅"  value="1"></el-option>
                            </el-select>
                            <el-select v-model="queryRecordParams.hasHand" @change="queryExamRes()" clearable placeholder="是否交卷" class="queryParam">
                                <el-option label="未交卷"  value="0" ></el-option>   
                                <el-option label="已交卷"  value="1"></el-option>
                            </el-select>
                            <el-button type="primary" @click="queryExamRes()" icon="el-icon-search" class="queryBtn"></el-button>  
                            <!-- <el-button type="info" @click="downloadResult()">成绩导出<i class="el-icon-download el-icon--right"></i></el-button> -->
                            <el-dropdown @command="downloadResultByType">
                                <el-button type="success">
                                    成绩导出<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="1">普通导出</el-dropdown-item>
                                    <el-dropdown-item command="2">分组导出</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                         </div>
                    </div>
                </div>
                <div class="recordDiv">
                    <!--考试记录展示表格-->
                    <el-table :data="recordList" height="505px"  stripe :header-cell-style="{background:'#eef1f6',color:'#606266'}">    
                        <el-table-column label="序号" align="center" type="index" width="50" ></el-table-column>     
                        <el-table-column prop="relayName" label="考生"   align="center"></el-table-column>
                        <el-table-column prop="examId" label="考试ID" v-if="false"></el-table-column>
                        <el-table-column prop="userId" label="考生ID" v-if="false"></el-table-column>
                        <el-table-column prop="paperScore" label="考生得分" align="center"></el-table-column>
                        <el-table-column prop="objectiveScore" label="客观题分数" align="center"></el-table-column>
                        <el-table-column prop="subjectiveScore" label="主观题分数" align="center"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="250"  align="center">
                            <template slot-scope="scope">
                                <div>
                                    <el-tooltip  effect="dark" :disabled="!tooltipDiabled" content="该试卷没有简答题，无需阅卷！" placement="left">
                                        <div>
                                            <el-button v-if="scope.row.hasCorrect == 1 && !tooltipDiabled" disabled type="info" size="small" style="width:150px">已批阅</el-button>
                                            <el-button v-else-if="scope.row.hasHand == 0" disabled type="warning" size="small" style="width:150px">未交卷</el-button>
                                            <el-button v-else @click="readThisExam(scope.row)" :disabled="tooltipDiabled" type="primary" size="small" style="width:150px">批阅试卷</el-button>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </template>

                        </el-table-column>
                    </el-table>
                </div>
                <!--分页信息底栏-->
                <el-pagination @size-change="recordSizeChange"  @current-change="recordCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                    :current-page="queryRecordParams.pageNum" :page-sizes="[8, 16, 32]" :page-size="queryRecordParams.pageSize" :total="recordTotalCount">
                </el-pagination>
            </div>
        </el-card>
        <!-- 批阅试卷对话框-->
        <el-dialog width="1100px" custom-class="reviewDialog" title="批阅试卷" :visible.sync="readExamDialogVisible" top="20px" style="height:900px" :append-to-body="true">
            <div class="dialog_bg">
                <el-scrollbar style="height:100%">
                    <div class="paper_container">
                        <div>
                            <h1 class="exam_name">{{examInfo.examName}}</h1>
                            <h2 class="exam_info_score">
                                <span class="info_score">时长：{{examInfo.examDuration}}分钟</span>&nbsp;&nbsp;
                                <span class="info_score">总分：{{examInfo.paper.paperScore}}分</span>&nbsp;&nbsp;
                                <span class="info_score">及格分：{{examInfo.paper.passScore}}分</span>
                            </h2>
                            <h2 class="exam_info_date">{{examInfo.examStartTime}} 至 {{examInfo.examEndTime}}</h2>
                            <h2 class="exam_info_user">
                                <span class="info_score">考生姓名： {{currentPaperInfo.examineeRelname}}</span>
                            </h2>
                        </div>                       
                        <div class="exam_content">
                            <el-button type="success"  @click="submitScore()" class="subBtn" size="mini">评分提交</el-button>
                            <table class="exam_question" v-for="(questionItem, index) in currentPaperInfo.questionList" :key="questionItem.questionId">
                                <thead >
                                    <tr class="theadTr">
                                        <div>
                                            <th>
                                                <span class="ques_index">{{index + 1}}</span>
                                            </th> 
                                            <td>{{questionItem.question.questionTitle}}</td>
                                        </div>
                                        <td>{{questionItem.incorrectQuestion.questionScore}} 分</td>
                                    </tr>
                                </thead>
                                <br><br>
                                <tfoot style="background-color:#F9F9F9">
                                    <tr>
                                        <td class="ques_bottom">
                                            <div>
                                                <div>
                                                    考生答案：<span>{{questionItem.incorrectQuestion.userAnswer}}</span>
                                                </div>
                                                <div>
                                                    参考答案：<span>{{questionItem.question.questionAnswer}}</span>
                                                </div>
                                            </div>
                                            <el-button size="mini" class="setScoreBtn" @click="openSetScoreDialog(questionItem)">
                                                    得分 {{questionItem.incorrectQuestion.answerScore}}分
                                            </el-button>
                                            <el-dialog width="300px" title="评分" custom-class="setScoreDialog" :visible.sync="setScoreDialogVisible" append-to-body top="300px">                  
                                                <div class="bg_div">
                                                    <div class="setTitle">
                                                        <h1>选择评分</h1>
                                                        <span>选择给该题的评分</span>
                                                    </div>
                                                    <div>
                                                        <el-button size="mini" class="setScoreBtn" @click="setScoreMin()">0</el-button>
                                                        <el-button size="mini" class="setScoreBtn" @click="setScoreMax()">{{currentPaperInfo.perScore}}</el-button>
                                                    </div>
                                                    <div class="setTitle">
                                                        <h1>填写评分</h1>
                                                        <span>填写给该题的评分</span>
                                                    </div>
                                                    <div>
                                                        <el-input size="mini"  style="width:100px;margin-right:5px" v-model="currentQuestion.wroteScore"></el-input>
                                                        <el-button size="mini" type="primary"  @click="setScoreWrote()">评分</el-button>
                                                    </div>
                                                </div>
                                            </el-dialog>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div> 
                </el-scrollbar>
                
            </div>
        </el-dialog>
    </div>  
</template>

<script>
import {queryExamResByExamId ,queryExamRes,queryExamAndPaper, reviewExam,queryIncorrectAnswers, correctSubjectiveScore,exportResult,exportResultGroup} from '../../api/exam'
import {queryExamPaperById, } from '../../api/examPaper'
import {queryQuestionTypeList} from '../../api/question'
import {queryUserList} from '../../api/user'
export default {
    data(){
        return {
            examInfo: {                     //考试基本信息
                paper:{}  
            },                   
            recordList: [],                 //考试记录表格数据
            recordTotalCount: 0,            //考试记录总条数
            queryRecordParams:{
                examId:'',
                userId:'',
                hasCorrect:'',
                //hasHand:'1',
                pageNum: 1,
                pageSize: 8
            },
            tooltipDiabled: false,
            readExamDialogVisible:false,    //批阅试卷对话框-显示标志
            currentPaperInfo:{},            //批阅试卷-所有信息
            currentQuestion: {
                questionId: '', 
                wroteScore:'',               //填写评分
            },
            questionTypeList:[],            //试卷试题类型
            setScoreDialogVisible: false,//设置分数对话框-显示标志                 
            userList:[]
        }
    },
    created(){
        //页面跳转获取examId,用于查询
        this.queryRecordParams.examId = this.$route.query.examId;
        this.queryExamAndPaper();
        this.queryExamRes();
        this.queryQuestionTypeList();
        this.loadAllUsers();
    },
    methods:{
        //返回考试管理页面
        backToExamManage(){
            this.$router.push({
                path:'/examManage'
            })
        },
        //刷新
        refresh(){
            location.reload();
        },
        //查询所有用户
        loadAllUsers(){
            queryUserList().then(res => {
                if(res.data.code === 200) {
                    this.userList = res.data.rows ? res.data.rows : [];
                 } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        //分页查询考试成绩
        queryExamResByExamId(){
            queryExamResByExamId(this.queryRecordParams).then(res => {
                if(res.data.code === 200) {
                    this.recordList = res.data.rows;
                    this.recordTotalCount = res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        //分页查询考试成绩(新)
        queryExamRes(){
            queryExamRes(this.queryRecordParams).then(res => {
                if(res.data.code === 200) {
                    this.recordList = res.data.rows;
                    this.recordTotalCount = res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },

        //改变分页每页显示数量
        recordSizeChange(val){
            this.queryRecordParams.pageSize = val;
            this.queryRecordParams.pageNum = 1;
            this.queryExamRes();
        },
        //改变分页页码
        recordCurrentChange(val){
            this.queryRecordParams.pageNum = val;
            this.queryExamRes();
        },
        //成绩导出
        downloadResult(){
            this.$confirm('请确认所有考生答卷均已批阅（如含简答题），防止导出的成绩有误，是否继续？',{
                confirmButtonText:'确定',
                cancelButtonText:'取消',
            }).then(()=>{
                const param = {
                    examId:this.$route.query.examId,
                    hasCorrect:'',
                    hasHand:'1',
                }
                exportResult(param).then(res => {
                    if(res.data.code === 200) {
                        let downloadUrl = this.$store.state.downloadUrl; 
                        const url = downloadUrl.split('/api')[0] + '/profile/download/' + res.data.msg;
                        //console.log(url);
                        fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                            const a = document.createElement('a')
                            a.href = URL.createObjectURL(blob)
                            a.download = this.examInfo.examName+ '_考生成绩.xlsx';  // 下载文件的名字
                            document.body.appendChild(a)
                            a.click()
                        })
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });   
                    }
                })
            }).catch(()=>{

            })
            
        },    
        downloadResultByType(type){
            this.$confirm('请确认所有考生答卷均已批阅（如含简答题），防止导出的成绩有误，是否继续？',{
                confirmButtonText:'确定',
                cancelButtonText:'取消',
            }).then(()=>{
                if(type == '1'){
                    const param = {
                        examId:this.$route.query.examId,
                        hasCorrect:'',
                        hasHand:'1',
                    }
                    exportResult(param).then(res => {
                        if(res.data.code === 200) {
                            let downloadUrl = this.$store.state.downloadUrl; 
                            const url = downloadUrl.split('/api')[0] + '/profile/download/' + res.data.msg;
                            //console.log(url);
                            fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                                const a = document.createElement('a')
                                a.href = URL.createObjectURL(blob)
                                a.download = this.examInfo.examName+ '_考生成绩.xlsx';  // 下载文件的名字
                                document.body.appendChild(a)
                                a.click()
                            })
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            });   
                        }
                    })

                }else if(type == '2'){
                    exportResultGroup(this.$route.query.examId).then(res => {
                        if(res.data.code === 200) {
                            let downloadUrl = this.$store.state.downloadUrl; 
                            const url = downloadUrl.split('/api')[0] + '/profile/download/' + res.data.msg;
                            //console.log(url);
                            fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                                const a = document.createElement('a')
                                a.href = URL.createObjectURL(blob)
                                a.download = this.examInfo.examName+ '_考生成绩.xlsx';  // 下载文件的名字
                                document.body.appendChild(a)
                                a.click()
                            })
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            });   
                        }
                    })
                }
            }).catch(()=>{

            })
        },
        //根据考试ID查询考试信息和试卷信息
        queryExamAndPaper(){
            const param = {
                examId: this.queryRecordParams.examId,
                userId: ''
            }
            //console.log(param);
            queryExamAndPaper(param).then(res => {
                if(res.data.code === 200) {
                    this.examInfo = res.data.data;
                    if(this.examInfo.paper.paperId !=null && this.examInfo.paper.paperId != undefined && this.examInfo.paper.paperId != ''){
                        this.queryPaperInfo();
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        //查询试卷信息
        queryPaperInfo(){
            queryExamPaperById(this.examInfo.paper.paperId).then(res => {
                //console.log(res);
                if(res.data.code === 200) {
                    const partList = res.data.data.examPartList;
                    let partStr = '';
                    partList.forEach(item =>{
                        partStr = partStr + item.partName; 
                    })
                    if(partStr.indexOf('简') != -1 ){
                        this.tooltipDiabled = false;
                    }else {
                        this.tooltipDiabled = true; 
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        //查询所有试题类型
        queryQuestionTypeList(){
            queryQuestionTypeList(this.questionTypeQueryParams).then(res => {               
                if(res.data.code === 200) {
                    this.questionTypeList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        }, 
        //批阅该考生试卷
        readThisExam(row){
            this.currentPaperInfo = {};
            //首先判断该试卷是否存在主观题
            let typeId = null;
            //拿出简答题typeId
            this.questionTypeList.forEach(item=>{
                if(item.typeName.indexOf('简') != -1){
                    typeId = item.typeId;
                }
            })
            const param = {
                examId:row.examId,
                userId:row.userId,
                typeId:typeId
            }
            queryIncorrectAnswers(param).then(res => {
                //console.log(res);
                if(res.data.code === 200) {
                    this.readExamDialogVisible = true;
                    this.currentPaperInfo.questionList = res.data.data;
                    this.currentPaperInfo.perScore= this.currentPaperInfo.questionList[0].incorrectQuestion.questionScore;
                    this.currentPaperInfo.userId = row.userId;
                    this.currentPaperInfo.examineeRelname = row.relayName;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })  
                
        },
        //简答题评分
        submitScore(){
            this.$confirm('确认所有题目均已评分?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //组装数据
                const param = {};
                param.examId = this.examInfo.examId;
                param.userId = this.currentPaperInfo.userId;
                param.questionOptions = [];
                for(let i= 0;i< this.currentPaperInfo.questionList.length;i++){
                    let option = {
                        questionId :this.currentPaperInfo.questionList[i].question.questionId,
                        answerScore: this.currentPaperInfo.questionList[i].incorrectQuestion.answerScore
                    }
                    param.questionOptions.push(option)
                }
                correctSubjectiveScore(param).then(res =>{
                    //console.log(res);
                   if(res.data.code === 200) {
                       this.$message({
                            message: '评分成功',
                            type: 'success'
                        }); 
                        this.readExamDialogVisible = false;
                        this.queryExamRes();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });   
                    } 
                })
            })
            
        },
        //简答题媒体评分
        openSetScoreDialog(questionItem){
            this.setScoreDialogVisible = true;
            this.currentQuestion.questionId = questionItem.question.questionId;
            this.currentQuestion.wroteScore ='';
        },
        //设置该题目得分为0
        setScoreMin(){
            this.currentPaperInfo.questionList.forEach(item => {
                if(item.question.questionId === this.currentQuestion.questionId){
                    item.incorrectQuestion.answerScore = 0;
                }
            })
            this.setScoreDialogVisible = false;
        },
        //设置该题目得分为最高分
        setScoreMax(){
            this.currentPaperInfo.questionList.forEach(item => {
                if(item.question.questionId === this.currentQuestion.questionId){
                    item.incorrectQuestion.answerScore = this.currentPaperInfo.perScore;
                }
            })
            this.setScoreDialogVisible = false;
        },
        //设置改题目得分（手动填写）
        setScoreWrote(){
            if(this.currentQuestion.wroteScore === '' || this.currentQuestion.wroteScore === undefined ){
                this.$message({
                    message: '您填写的评分不能为空！',
                    type: 'warning'
                }); 
                return
            }
            var patrn= /^[+]{0,1}[1-9]\d*$|^[+]{0,1}(0\.\d*[1-9])$|^[+]{0,1}([1-9]\d*\.\d*[1-9])$/;
            if(!this.currentQuestion.wroteScore.match(patrn)){
                this.$message({
                    message: '您填写的评分不是正数，请正确填写！',
                    type: 'warning'
                }); 
                return
            }
            if(this.currentQuestion.wroteScore > this.currentPaperInfo.perScore){
                this.$message({
                    message: '您填写的评分不能大于每题默认分值（'+  this.currentPaperInfo.perScore +  '）',
                    type: 'warning'
                }); 
                return
            }
            this.currentPaperInfo.questionList.forEach(item => {
                if(item.question.questionId === this.currentQuestion.questionId){
                    item.incorrectQuestion.answerScore = this.currentQuestion.wroteScore;
                }
            })
            this.setScoreDialogVisible = false;
        },

  
    }
}
</script>

<style lang="less" scoped>  
    .fatherCard {
        width: 1672px;
    position: fixed;
    height: 90vh;
        .page_content {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .exam_info {
                width: 100%;
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
                .left_info{
                    .info_title {
                        margin-bottom: 10px;
                        .singAnswerTip {
                            font-size: 15px;
                            color: #909399;
                        }
                    }
                    .info_table {
                        width: 600px;
                        border-collapse: collapse;
                        border: solid 1px #eee;
                        th {
                            font-weight: normal;
                            text-align: right;
                            font-size: 12px;
                            border: solid 1px #eee;
                            background: #f5f5f5;
                            line-height: 25px;
                            padding: 5px 5px;
                        }
                        td {
                            border: solid 1px #eee;
                            padding: 5px 5px;
                            font-size: 9pt;
                        }
                    }
                }
                .right_area {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-end;
                    .queryParam {
                        width: 150px;
                        margin-right: 5px;
                    }
                    .queryBtn{
                        margin-right: 15px;
                    }
                }
            }
            .recordDiv{
                width: 100%;
                margin-bottom: 5px;
            }
        }
    }
    .reviewDialog {
        .dialog_bg{
            height: 900px;
            .paper_container {
                display: flex;
                flex-direction: column;
                align-items: center;
                .exam_name{
                    font-size: 20px;
                    font-weight: bold;
                    text-align: center;
                    font-family: "Microsoft Yahei",Arial, Helvetica, sans-serif;
                    margin: 0 auto 20px auto;  
                }
                .exam_info_score {
                    font-size: 12px;
                    font-weight: normal;
                    text-align: center;
                    color: #000;
                    margin: 20px auto;
                    
                }
                .info_score{
                    background-color: #f5f5f5;
                    color: #000;
                    font-weight: normal;
                    padding: 5px 10px !important;
                }
                .exam_info_date{
                    font-size: 12px;
                    font-weight: normal;
                    text-align: center;
                    color: #aaa;
                    margin: 20px auto;
                }
                 .exam_info_user {
                    font-size: 12px;
                    font-weight: normal;
                    text-align: center;
                    color: #000;
                    margin: 10px auto 20px auto;
                }
                .exam_content {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    .subBtn{
                        margin-bottom: 5px;
                    }
                    .exam_question {
                        border-collapse: collapse;
                        margin: 0 auto 20px auto;
                        border: solid 1px #eee;
                        width: 100%;
                        .theadTr{
                            display: flex;
                            justify-content: space-between;
                            padding-top: 5px;
                            .ques_index {
                                background-color: #1e88e5;
                                color: #fff;
                                white-space: nowrap;
                                display: inline;
                                padding: .2em .6em .3em;
                                font-weight: 700;
                                line-height: 1;
                                text-align: center;
                                white-space: nowrap;
                                vertical-align: baseline;
                                border-radius: .25em;
                            }            
                        }
                        .ques_bottom {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                       
                        }
                    }
                }
            }
        }
    }
    .setScoreDialog{
        .bg_div{
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            .el-button{
                margin-bottom: 10px;
            }
            .setTitle {
                display: flex;
                align-items: flex-end;
                margin-bottom: 5px;
                
                h1{
                    font-size: 16px;
                    font-weight: bold;
                    margin-right: 10px;
                }
                span{
                    font-size: 12px;
                    font-weight: normal;
                    color: #aaa;
                }
            }

        }
    }
    .setScoreBtn {
        border: 1px solid #ef5350;
        color: #ef5350 !important;
    }
    /deep/ .el-dropdown-menu__item {
        width: 117px;
        text-align: center;
    }
    /deep/ .el-dropdown-menu__item:focus, /deep/ .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: #c2e6aa;
        color:  #000
    }

</style>